import {
    actionCreatorFactory,
    AsyncActionCreators,
    ActionCreator,
} from 'typescript-fsa';
import {
    PartsProduct,
    OrdermadeArrowPartsName,
    MAKIWARA_THREAD_MODE,
    FamilyCrestColor,
    GetResponseCartItemData,
} from '@app/react/const/type';

const actionCreator = actionCreatorFactory('selectAction');

export interface IPartsSelectParam {
    param: PartsProduct | null;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IPartsSelectResult { }

export interface IPartsSelectError {
    message: string;
}

interface IPartsSelectBaseActions {
    shaft: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    confirmShaft: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    feather: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    confirmFeather: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    confirmFeatherWithMakiwara: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    thread: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    kebiki: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    nock: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    arrowhead: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    unit: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    arrowinsert: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    twine: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    lame: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    familycrest: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    typezero: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    decoration: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
    featherinside: AsyncActionCreators<IPartsSelectParam, IPartsSelectResult, IPartsSelectError>;
}

interface IpartsSelectActions extends IPartsSelectBaseActions {
    arrowlength: AsyncActionCreators<
        IArrowlengthSelectParam, IPartsSelectResult, IPartsSelectError
    >;
    carving: AsyncActionCreators<ICarvingSelectParam, IPartsSelectResult, IPartsSelectError>;
    fafamilycrestColor: AsyncActionCreators<
        IFamilyCrestColorSelectParam, IFamilyCrestColorSelectResult, IFamilyCrestColorSelectError
    >;
    threadGloss: ActionCreator<{ gloss: boolean }>;
    threadMode: ActionCreator<{ mode: MAKIWARA_THREAD_MODE }>;
}

const basicActionNames: Array<keyof IPartsSelectBaseActions> = [
    OrdermadeArrowPartsName.Shaft,
    'confirmShaft',
    OrdermadeArrowPartsName.Feather,
    'confirmFeather',
    'confirmFeatherWithMakiwara',
    OrdermadeArrowPartsName.Thread,
    OrdermadeArrowPartsName.Kebiki,
    OrdermadeArrowPartsName.Nock,
    OrdermadeArrowPartsName.Arrowhead,
    OrdermadeArrowPartsName.Unit,
    OrdermadeArrowPartsName.Arrowinsert,
    OrdermadeArrowPartsName.Twine,
    OrdermadeArrowPartsName.Lame,
    OrdermadeArrowPartsName.Typezero,
    OrdermadeArrowPartsName.Decoration,
    OrdermadeArrowPartsName.Featherinside,
    OrdermadeArrowPartsName.Familycrest,
];
const x: IPartsSelectBaseActions = basicActionNames.reduce((acc, parts) => {
    acc[parts] = actionCreator.async<
        IPartsSelectParam,
        IPartsSelectResult,
        IPartsSelectError
    >(parts);
    return acc;
}, {} as IPartsSelectBaseActions);

export const partsSelectActions: IpartsSelectActions = {
    ...x,
    carving: actionCreator.async<
        ICarvingSelectParam,
        IPartsSelectResult,
        IPartsSelectError
    >('carving'),
    fafamilycrestColor: actionCreator.async<
        IFamilyCrestColorSelectParam,
        IFamilyCrestColorSelectResult,
        IFamilyCrestColorSelectError
    >('familycrestColor'),
    arrowlength: actionCreator.async<
        IArrowlengthSelectParam,
        IPartsSelectResult,
        IPartsSelectError
    >('arrowlength'),
    threadGloss: actionCreator<{ gloss: boolean }>('changeThreadMatte'),
    threadMode: actionCreator<{ mode: MAKIWARA_THREAD_MODE }>(
        'changeThreadMode',
    ),
};

export interface ICarvingSelectParam {
    carvingOk: boolean;
    carving: PartsProduct | null;
    carvingString: string | null;
}

export interface IFamilyCrestColorSelectParam {
    param: FamilyCrestColor | null;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IFamilyCrestColorSelectResult { }

export interface IFamilyCrestColorSelectError {
    message: string;
}

export interface IArrowlengthSelectParam {
    adjust: boolean;
    arrowlength: PartsProduct | null;
}

export const partsSelectAllAction = actionCreator<GetResponseCartItemData>(
    'partsSelectAllAction',
);

export const setFamilycrestOk = actionCreator<{ ok: boolean }>(
    'setFamilycrestOk',
);
